/**
 * kpw-inbox.js — KPW フローティング問い合わせ LINE風チャットUI
 * v2.2 — 横長ピルFAB・目立つデザイン・インラインCSS・複数スレッド対応
 */
(function () {
  'use strict';

  /* ════════════════════════════════════════════
   * 1. 設定・デバッグログ
   * ════════════════════════════════════════════ */
  var C         = window.KPW_CONFIG || {};
  var API_URL   = String(C.apiUrl   || '').replace(/\/$/, '');
  var IS_LOGIN  = !!C.isLoggedIn;
  var CUST_ID   = C.customerId ? String(C.customerId) : '';
  var CUST_NAME = String(C.customerName  || '');
  var CUST_EMAIL= String(C.customerEmail || '');
  var PAGE_TYPE = String(C.pageType      || 'general');
  var PROD_ID   = C.productId     ? String(C.productId)     : null;
  var PROD_HDL  = C.productHandle ? String(C.productHandle) : null;
  var PROD_TTL  = C.productTitle  ? String(C.productTitle)  : null;
  var LOGIN_URL = String(C.loginUrl || '/account/login');
  var AUTH_TOKEN_URL = String(C.authTokenUrl || '/apps/kpw-inbox/auth/token').trim();
  var CUSTOMER_AUTH_REQUIRED = !!C.customerAuthRequired;
  var IS_PRODUCT= (PAGE_TYPE === 'product' && !!PROD_ID);
  var AUTO_OPEN_MESSAGE = shouldAutoOpenMessage();
  var AUTO_OPEN_GUARD_KEY = 'kpwMessageAutoOpenRedirect';

  console.log('[KPWFloat] widget init');

  function shouldAutoOpenMessage() {
    var search = window.location.search || '';
    if (!search || search === '?') return false;
    if (typeof URLSearchParams !== 'undefined') {
      return new URLSearchParams(search).get('kpw_message') === 'open';
    }
    var query = search.charAt(0) === '?' ? search.slice(1) : search;
    var parts = query.split('&');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      var pair = parts[i].split('=');
      var key = decodeURIComponent((pair[0] || '').replace(/\+/g, ' '));
      var value = decodeURIComponent((pair.slice(1).join('=') || '').replace(/\+/g, ' '));
      if (key === 'kpw_message') return value === 'open';
    }
    return false;
  }

  function currentRelativeUrl() {
    return window.location.pathname + window.location.search;
  }

  function redirectToLoginForAutoOpen() {
    var current = currentRelativeUrl();
    try {
      if (window.sessionStorage && sessionStorage.getItem(AUTO_OPEN_GUARD_KEY) === current) {
        return false;
      }
      if (window.sessionStorage) sessionStorage.setItem(AUTO_OPEN_GUARD_KEY, current);
    } catch (e) {}
    window.location.assign('/account/login?return_url=' + encodeURIComponent(current));
    return true;
  }

  function removeAutoOpenQuery() {
    if (!AUTO_OPEN_MESSAGE || !window.history || !history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('kpw_message');
      var next = url.pathname + url.search + url.hash;
      history.replaceState(history.state, document.title, next);
    } catch (e) {
      var search = window.location.search || '';
      if (!search) return;
      var query = search.charAt(0) === '?' ? search.slice(1) : search;
      var kept = [];
      var parts = query.split('&');
      for (var i = 0; i < parts.length; i++) {
        if (!parts[i]) continue;
        var key = decodeURIComponent(parts[i].split('=')[0].replace(/\+/g, ' '));
        if (key !== 'kpw_message') kept.push(parts[i]);
      }
      var fallback = window.location.pathname + (kept.length ? '?' + kept.join('&') : '') + window.location.hash;
      history.replaceState(history.state, document.title, fallback);
    }
  }

  function runAutoOpenMessage() {
    if (!AUTO_OPEN_MESSAGE || window.__KPW_MESSAGE_AUTO_OPEN_DONE__) return;
    window.__KPW_MESSAGE_AUTO_OPEN_DONE__ = true;
    if (!IS_LOGIN) {
      if (!redirectToLoginForAutoOpen()) openPanel();
      return;
    }
    try {
      if (window.sessionStorage) sessionStorage.removeItem(AUTO_OPEN_GUARD_KEY);
    } catch (e) {}
    openPanel();
    removeAutoOpenQuery();
  }

  /* ════════════════════════════════════════════
   * 2. インラインCSSを注入（外部CSSが読めなくても動作保証）
   * ════════════════════════════════════════════ */
  var CRITICAL_CSS = [
    /* ── FAB 横長ピルボタン ── */
    '.kpw-f-fab{',
      'position:fixed!important;',
      'bottom:24px!important;right:20px!important;',
      'z-index:2147483647!important;',
      'height:56px!important;',
      'padding:0 22px 0 18px!important;',
      'border-radius:30px!important;',
      'background:linear-gradient(135deg,#16a34a,#22c55e)!important;',
      'border:none!important;cursor:pointer!important;',
      'display:flex!important;align-items:center!important;gap:10px!important;',
      'box-shadow:0 6px 24px rgba(22,163,74,.45),0 2px 8px rgba(22,163,74,.25)!important;',
      'white-space:nowrap!important;',
      'animation:kpwFabIn .45s cubic-bezier(.34,1.56,.64,1) both!important;',
      'transition:transform .2s ease,box-shadow .2s ease!important;',
    '}',
    '@keyframes kpwFabIn{',
      'from{opacity:0;transform:translateY(16px) scale(.88);}',
      'to  {opacity:1;transform:translateY(0)    scale(1);}',
    '}',
    '.kpw-f-fab:hover{',
      'transform:translateY(-3px) scale(1.03)!important;',
      'box-shadow:0 12px 32px rgba(22,163,74,.55),0 4px 12px rgba(22,163,74,.3)!important;',
    '}',
    '.kpw-f-fab.is-hidden{display:none!important;}',
    'body.kpw-f-panel-open .kpw-f-fab{display:none!important;}',
    /* アイコン */
    '.kpw-f-fab-icon{',
      'display:flex;align-items:center;justify-content:center;',
      'flex-shrink:0;pointer-events:none;',
    '}',
    /* ラベル */
    '.kpw-f-fab-label{',
      'font-size:14px;font-weight:700;',
      'color:#fff;letter-spacing:.04em;',
      'pointer-events:none;',
      'font-family:-apple-system,BlinkMacSystemFont,"Helvetica Neue","Hiragino Sans",sans-serif;',
    '}',
    /* FAB — スマホ */
    '@media(max-width:479px){',
      '.kpw-f-fab{height:52px!important;padding:0 18px 0 14px!important;bottom:20px!important;right:auto!important;left:16px!important;}',
      '.kpw-f-fab-label{font-size:13px;}',
    '}',
    /* バッジ（右上に絶対配置） */
    '.kpw-f-badge{',
      'position:absolute;top:-7px;right:-7px;',
      'min-width:20px;height:20px;',
      'background:#dc2626;color:#fff;',
      'font-size:11px;font-weight:700;border-radius:10px;padding:0 5px;',
      'display:flex;align-items:center;justify-content:center;',
      'box-sizing:border-box;pointer-events:none;',
      'border:2px solid #fff;',
      'animation:kpwBadgePop .25s cubic-bezier(.34,1.56,.64,1) both;',
    '}',
    '@keyframes kpwBadgePop{from{transform:scale(0);}to{transform:scale(1);}}',
    '.kpw-f-badge.is-hidden{display:none;}',
    /* パネル */
    '.kpw-f-panel{',
      'position:fixed!important;z-index:2147483646!important;',
      'background:#fff;',
      'box-shadow:0 8px 40px rgba(0,0,0,.22);',
      'display:flex;flex-direction:column;',
      'bottom:92px;right:20px;',
      'width:360px;height:540px;',
      'border-radius:14px;overflow:hidden;',
      'visibility:hidden;opacity:0;',
      'transform:translateY(12px) scale(.97);',
      'transition:opacity .2s,transform .2s,visibility 0s linear .2s;',
    '}',
    '.kpw-f-panel.is-open{visibility:visible;opacity:1;transform:none;transition:opacity .2s,transform .2s,visibility 0s;}',
    '@media(max-width:479px){',
      '.kpw-f-panel{bottom:0;right:0;left:0;width:100%;height:90vh;max-height:90vh;border-radius:14px 14px 0 0;transform:translateY(100%);}',
      '.kpw-f-panel.is-open{transform:translateY(0);}',
    '}',
    /* オーバーレイ */
    '.kpw-f-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:2147483645;}',
    '.kpw-f-overlay.is-open{display:block;}',
    '@media(min-width:480px){.kpw-f-overlay{display:none!important;}}',
    /* ヘッダー */
    '.kpw-f-header{display:flex;align-items:center;justify-content:space-between;padding:12px 14px 10px;border-bottom:1px solid #e5e7eb;flex-shrink:0;background:#fff;}',
    '.kpw-f-header-left{display:flex;align-items:center;gap:8px;min-width:0;flex:1;}',
    '.kpw-f-header-avatar{width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg,#0f172a,#1e293b);display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
    '.kpw-f-header-text{min-width:0;}',
    '.kpw-f-header-title{font-size:13px;font-weight:700;color:#111827;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:0;}',
    '.kpw-f-header-sub{font-size:11px;color:#6b7280;margin:1px 0 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.kpw-f-header-actions{display:flex;align-items:center;gap:2px;flex-shrink:0;}',
    '.kpw-f-icon-btn{background:none;border:none;cursor:pointer;color:#6b7280;padding:6px;border-radius:6px;display:flex;align-items:center;justify-content:center;transition:background .1s;line-height:0;flex-shrink:0;}',
    '.kpw-f-icon-btn:hover{background:#f3f4f6;color:#111827;}',
    /* コンテンツ */
    '.kpw-f-content{flex:1;display:flex;flex-direction:column;overflow:hidden;min-height:0;}',
    /* スレッド一覧 */
    '.kpw-f-list-wrap{flex:1;overflow-y:auto;display:flex;flex-direction:column;}',
    '.kpw-f-thread-item{padding:12px 16px;border-bottom:1px solid #f3f4f6;cursor:pointer;transition:background .12s;flex-shrink:0;}',
    '.kpw-f-thread-item:last-child{border-bottom:none;}',
    '.kpw-f-thread-item:hover{background:#f9fafb;}',
    '.kpw-f-thread-item.has-unread{background:#f0f6ff;border-left:3px solid #2563eb;}',
    '.kpw-f-ti-main{display:flex;align-items:flex-start;justify-content:space-between;gap:8px;}',
    '.kpw-f-ti-subject{font-size:13px;font-weight:500;color:#374151;line-height:1.4;flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.kpw-f-ti-subject.is-unread{font-weight:700;color:#111827;}',
    '.kpw-f-ti-time{font-size:11px;color:#9ca3af;flex-shrink:0;margin-top:1px;}',
    '.kpw-f-ti-foot{display:flex;align-items:center;justify-content:space-between;margin-top:6px;}',
    '.kpw-f-ti-badges{display:flex;gap:4px;flex-wrap:wrap;}',
    '.kpw-f-tbadge{display:inline-flex;padding:1px 6px;border-radius:10px;font-size:10px;font-weight:600;}',
    '.kpw-f-tbadge-product{background:#d1fae5;color:#065f46;}',
    '.kpw-f-tbadge-order{background:#e0e7ff;color:#3730a3;}',
    '.kpw-f-tbadge-general{background:#f3f4f6;color:#374151;}',
    '.kpw-f-tbadge-open{background:#dbeafe;color:#1d4ed8;}',
    '.kpw-f-tbadge-progress{background:#fef9c3;color:#92400e;}',
    '.kpw-f-tbadge-closed{background:#f3f4f6;color:#6b7280;}',
    '.kpw-f-ti-unread{min-width:18px;height:18px;background:#dc2626;color:#fff;font-size:10px;font-weight:700;border-radius:9px;padding:0 4px;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;}',
    /* メッセージ */
    '.kpw-f-messages{flex:1;overflow-y:auto;padding:12px 14px;display:flex;flex-direction:column;gap:4px;scroll-behavior:smooth;}',
    '.kpw-f-date-sep{display:flex;align-items:center;gap:8px;font-size:11px;color:#9ca3af;margin:8px 0;flex-shrink:0;}',
    '.kpw-f-date-sep::before,.kpw-f-date-sep::after{content:"";flex:1;border-top:1px solid #e5e7eb;}',
    '.kpw-f-msg-row{display:flex;gap:8px;align-items:flex-end;}',
    '.kpw-f-from-customer{flex-direction:row-reverse;}',
    '.kpw-f-msg-avatar{width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#0f172a,#1e293b);color:#fff;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0;letter-spacing:-.5px;}',
    '.kpw-f-msg-content{display:flex;flex-direction:column;max-width:78%;}',
    '.kpw-f-from-customer .kpw-f-msg-content{align-items:flex-end;}',
    '.kpw-f-bubble{padding:9px 12px;border-radius:16px;font-size:13px;line-height:1.55;word-break:break-word;white-space:pre-wrap;}',
    '.kpw-f-bubble:empty{display:none;}',
    '.kpw-f-from-staff .kpw-f-bubble{background:#f3f4f6;color:#111827;border-bottom-left-radius:4px;}',
    '.kpw-f-from-customer .kpw-f-bubble{background:#2563eb;color:#fff;border-bottom-right-radius:4px;}',
    '.kpw-f-msg-attachments{display:flex;flex-wrap:wrap;gap:6px;margin-top:6px;max-width:246px;}',
    '.kpw-f-msg-attachment{display:block;width:76px;height:76px;border-radius:8px;overflow:hidden;background:#f3f4f6;border:1px solid #e5e7eb;cursor:zoom-in;}',
    '.kpw-f-msg-attachment img{width:100%;height:100%;object-fit:cover;display:block;}',
    '.kpw-f-msg-attachment-error{font-size:12px;color:#dc2626;margin-top:4px;}',
    '.kpw-f-msg-meta{font-size:10px;color:#9ca3af;margin-top:3px;padding:0 2px;}',
    /* 入力 */
    '.kpw-f-input-area{border-top:1px solid #e5e7eb;padding:10px 12px;display:flex;gap:8px;align-items:flex-end;flex-shrink:0;background:#fff;}',
    '.kpw-f-input-stack{border-top:1px solid #e5e7eb;padding:8px 12px 10px;flex-shrink:0;background:#fff;}',
    '.kpw-f-input-stack .kpw-f-input-area{border-top:0;padding:0;}',
    '.kpw-f-chat-input{flex:1;padding:8px 12px;border:1px solid #d1d5db;border-radius:20px;font-size:13px;font-family:inherit;color:#111827;resize:none;outline:none;line-height:1.4;max-height:100px;overflow-y:auto;box-sizing:border-box;background:#fff;transition:border-color .15s;}',
    '.kpw-f-chat-input:focus{border-color:#2563eb;}',
    '.kpw-f-attach-btn{width:36px;height:36px;border-radius:50%;background:#f3f4f6;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;color:#374151;font-size:18px;transition:background .15s,opacity .15s;}',
    '.kpw-f-attach-btn:hover{background:#e5e7eb;}',
    '.kpw-f-attach-btn.is-disabled{opacity:.5;cursor:not-allowed;pointer-events:none;}',
    '.kpw-f-file-input{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;}',
    '.kpw-f-send-btn{width:36px;height:36px;border-radius:50%;background:#2563eb;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:background .15s,opacity .15s;line-height:0;}',
    '.kpw-f-send-btn:hover{background:#1d4ed8;}',
    '.kpw-f-send-btn:disabled{opacity:.5;cursor:not-allowed;}',
    '.kpw-f-attach-preview{display:none;flex-wrap:wrap;gap:6px;margin:0 0 8px;}',
    '.kpw-f-attach-preview.is-show{display:flex;}',
    '.kpw-f-attach-item{position:relative;width:64px;height:64px;border-radius:8px;overflow:hidden;border:1px solid #e5e7eb;background:#f3f4f6;flex-shrink:0;}',
    '.kpw-f-attach-item img{width:100%;height:100%;object-fit:cover;display:block;cursor:zoom-in;}',
    '.kpw-f-attach-remove{position:absolute;top:3px;right:3px;width:20px;height:20px;border:0;border-radius:50%;background:rgba(17,24,39,.78);color:#fff;font-size:14px;line-height:20px;padding:0;cursor:pointer;}',
    '.kpw-f-attach-error{display:none;color:#dc2626;font-size:12px;margin:0 0 6px;padding:0 2px;}',
    '.kpw-f-attach-error.is-show{display:block;}',
    '.kpw-f-lightbox{position:fixed;inset:0;z-index:2147483647;display:none;align-items:center;justify-content:center;padding:20px;background:rgba(15,23,42,.78);}',
    '.kpw-f-lightbox.is-open{display:flex;}',
    '.kpw-f-lightbox img{max-width:96vw;max-height:92vh;border-radius:10px;background:#fff;box-shadow:0 18px 50px rgba(0,0,0,.35);}',
    '.kpw-f-lightbox button{position:fixed;top:14px;right:14px;width:36px;height:36px;border:0;border-radius:50%;background:#fff;cursor:pointer;font-size:20px;color:#111827;}',
    /* フォーム */
    '.kpw-f-form-wrap{flex:1;display:flex;flex-direction:column;overflow-y:auto;padding:14px 16px;}',
    '.kpw-f-field{margin-bottom:12px;}',
    '.kpw-f-label{display:block;font-size:12px;font-weight:600;color:#374151;margin-bottom:4px;}',
    '.kpw-f-req{color:#dc2626;margin-left:2px;}',
    '.kpw-f-input{display:block;width:100%;padding:8px 10px;border:1px solid #d1d5db;border-radius:8px;font-size:13px;font-family:inherit;color:#111827;outline:none;box-sizing:border-box;-webkit-appearance:none;background:#fff;transition:border-color .15s,box-shadow .15s;}',
    '.kpw-f-input:focus{border-color:#2563eb;box-shadow:0 0 0 3px rgba(37,99,235,.1);}',
    '.kpw-f-input-ta{resize:vertical;min-height:80px;line-height:1.5;}',
    '.kpw-f-form-attachments{margin:0 0 12px;padding:10px;border:1px solid #e5e7eb;border-radius:10px;background:#f9fafb;}',
    '.kpw-f-form-attach-row{display:flex;align-items:center;justify-content:space-between;gap:10px;}',
    '.kpw-f-form-attach-help{font-size:11px;color:#6b7280;line-height:1.45;}',
    '.kpw-f-form-attach-btn{display:inline-flex;align-items:center;justify-content:center;min-height:40px;padding:8px 12px;border:1px solid #9ca3af;border-radius:8px;background:#fff;color:#111827;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;}',
    '.kpw-f-form-attach-btn.is-disabled{opacity:.5;cursor:not-allowed;pointer-events:none;}',
    '.kpw-f-form-error{color:#dc2626;font-size:12px;min-height:16px;margin:0 0 8px;}',
    '.kpw-f-form-actions{display:flex;justify-content:flex-end;}',
    '.kpw-f-btn-primary{display:inline-flex;align-items:center;justify-content:center;padding:9px 20px;border-radius:8px;font-size:13px;font-weight:600;font-family:inherit;cursor:pointer;border:none;background:#2563eb;color:#fff;transition:background .15s,opacity .15s;}',
    '.kpw-f-btn-primary:hover:not(:disabled){background:#1d4ed8;}',
    '.kpw-f-btn-primary:disabled{opacity:.5;cursor:not-allowed;}',
    /* ログイン */
    '.kpw-f-login-wrap{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:24px 16px;text-align:center;}',
    '.kpw-f-login-msg{font-size:13px;color:#374151;line-height:1.6;margin:0 0 16px;}',
    '.kpw-f-login-link{display:inline-flex;align-items:center;padding:10px 22px;background:linear-gradient(135deg,#0f172a,#1e293b);color:#fff;border-radius:8px;font-size:13px;font-weight:600;text-decoration:none;transition:opacity .15s;}',
    '.kpw-f-login-link:hover{opacity:.85;}',
    /* ローディング */
    '.kpw-f-loading-wrap{flex:1;display:flex;align-items:center;justify-content:center;}',
    '.kpw-f-spinner{width:28px;height:28px;border:3px solid #e5e7eb;border-top-color:#2563eb;border-radius:50%;animation:kpwSpin .7s linear infinite;}',
    '@keyframes kpwSpin{to{transform:rotate(360deg)}}',
    /* 空状態 */
    '.kpw-f-empty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:24px;text-align:center;color:#9ca3af;font-size:13px;line-height:1.6;gap:16px;}',
    '.kpw-f-empty p{margin:0;}',
  ].join('');

  var styleEl = document.createElement('style');
  styleEl.id = 'kpw-f-style';
  styleEl.textContent = CRITICAL_CSS;
  document.head.appendChild(styleEl);

  /* ════════════════════════════════════════════
   * 3. localStorage
   * ════════════════════════════════════════════ */
  var LS_PFX = 'kpw_' + (CUST_ID || 'guest') + '_';

  function lsGet(k)    { try { return localStorage.getItem(LS_PFX + k);     } catch(e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(LS_PFX + k, String(v)); } catch(e) {} }

  /* ════════════════════════════════════════════
   * 4. 状態
   * ════════════════════════════════════════════ */
  var S = {
    open           : false,
    view           : '',
    threads        : [],
    currentThreadId: null,
    thread         : null,
    sending        : false,
    pollTimer      : null,
    bgTimer        : null,
    msgCount       : 0,
    attachments    : [],
    attachmentUrls : [],
    attachmentCache: {},
    authToken      : null,
    authTokenExp   : 0,
  };

  var ATTACH_MAX_FILES = 5;
  var ATTACH_MAX_FILE_BYTES = 10 * 1024 * 1024;
  var ATTACH_MAX_TOTAL_BYTES = 30 * 1024 * 1024;
  var ATTACH_TYPES = {
    'image/jpeg': true,
    'image/png': true,
    'image/webp': true,
    'image/heic': true,
    'image/heif': true,
  };
  var ATTACH_EXT_RE = /\.(jpe?g|png|webp|heic|heif)$/i;

  /* ════════════════════════════════════════════
   * 5. ユーティリティ
   * ════════════════════════════════════════════ */
  function esc(s) {
    return String(s || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function parseUtcDate(iso) {
    if (!iso) return null;
    var s = String(iso);
    if (!/([zZ]|[+-]\d{2}:?\d{2})$/.test(s)) s += 'Z';
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }
  var jstTimeFormatter = new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  var jstMonthDayFormatter = new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo',
    month: 'numeric',
    day: 'numeric'
  });
  var jstDateKeyFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  function jstDayNumber(d) {
    var parts = jstDateKeyFormatter.format(d).split('-');
    return Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])) / 86400000;
  }
  function fmtJstMonthDay(d) {
    var parts = jstMonthDayFormatter.formatToParts(d);
    var month = '', day = '';
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'month') month = parts[i].value;
      if (parts[i].type === 'day') day = parts[i].value;
    }
    return month + '月' + day + '日';
  }
  function fmtTime(iso) {
    if (!iso) return '';
    var d = parseUtcDate(iso);
    return d ? jstTimeFormatter.format(d) : '';
  }
  function fmtDateLabel(iso) {
    if (!iso) return '';
    var d = parseUtcDate(iso);
    if (!d) return '';
    var diff = jstDayNumber(new Date()) - jstDayNumber(d);
    if (diff < 1) return '今日';
    if (diff < 2) return '昨日';
    return fmtJstMonthDay(d);
  }
  function fmtRelative(iso) {
    if (!iso) return '';
    var d = parseUtcDate(iso), now = new Date();
    if (!d) return '';
    var diffMs = now.getTime() - d.getTime();
    if (diffMs < 86400000) return fmtTime(iso);
    var diffDays = jstDayNumber(now) - jstDayNumber(d);
    if (diffDays < 2) return '昨日';
    if (diffDays < 7) return Math.floor(diffDays) + '日前';
    return fmtJstMonthDay(d).replace('月', '/').replace('日', '');
  }

  var TYPE_LABELS  = { product:'商品', order:'注文', general:'一般' };
  var STATUS_LABELS= { open:'未対応', in_progress:'対応中', closed:'完了' };
  var TYPE_CLASS   = { product:'kpw-f-tbadge-product', order:'kpw-f-tbadge-order', general:'kpw-f-tbadge-general' };
  var STATUS_CLASS = { open:'kpw-f-tbadge-open', in_progress:'kpw-f-tbadge-progress', closed:'kpw-f-tbadge-closed' };

  /* ════════════════════════════════════════════
   * 6. DOM 構築
   * ════════════════════════════════════════════ */
  function buildDOM() {
    var overlay = document.createElement('div');
    overlay.id = 'kpw-f-overlay';
    overlay.className = 'kpw-f-overlay';

    var panel = document.createElement('div');
    panel.id = 'kpw-f-panel';
    panel.className = 'kpw-f-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'お問い合わせ');
    panel.innerHTML = [
      '<div class="kpw-f-header">',
        '<div class="kpw-f-header-left">',
          '<button type="button" id="kpw-f-back-btn" class="kpw-f-icon-btn" aria-label="戻る" style="display:none">',
            svgBack(18),
          '</button>',
          '<div id="kpw-f-h-avatar" class="kpw-f-header-avatar">', svgChat(16,'#fff'), '</div>',
          '<div class="kpw-f-header-text">',
            '<p class="kpw-f-header-title" id="kpw-f-h-title">KPW サポート</p>',
            '<p class="kpw-f-header-sub"   id="kpw-f-h-sub">クワガタ・カブトムシ用品専門</p>',
          '</div>',
        '</div>',
        '<div class="kpw-f-header-actions">',
          '<button type="button" id="kpw-f-new-btn" class="kpw-f-icon-btn" aria-label="新規問い合わせ" style="display:none">',
            svgPlus(18),
          '</button>',
          '<button type="button" id="kpw-f-close-btn" class="kpw-f-icon-btn" aria-label="閉じる">',
            svgClose(18),
          '</button>',
        '</div>',
      '</div>',
      '<div id="kpw-f-content" class="kpw-f-content"></div>',
    ].join('');

    /* ── 横長ピルFAB ── */
    var fab = document.createElement('button');
    fab.type = 'button';
    fab.id = 'kpw-f-fab';
    fab.className = 'kpw-f-fab';
    fab.setAttribute('aria-label', 'お問い合わせ');
    fab.setAttribute('aria-expanded', 'false');
    fab.innerHTML =
      '<span class="kpw-f-fab-icon">' + svgChat(20, '#fff') + '</span>' +
      '<span class="kpw-f-fab-label">お問い合わせ</span>' +
      '<span id="kpw-f-badge" class="kpw-f-badge is-hidden"></span>';

    var lightbox = document.createElement('div');
    lightbox.id = 'kpw-f-lightbox';
    lightbox.className = 'kpw-f-lightbox';
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = '<button type="button" id="kpw-f-lightbox-close" aria-label="Close">&times;</button><img id="kpw-f-lightbox-img" alt="attachment preview">';

    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    document.body.appendChild(fab);
    document.body.appendChild(lightbox);

    console.log('[KPWFloat] FAB mounted:', fab);

    return {
      overlay : overlay, panel   : panel, fab     : fab,
      badge   : document.getElementById('kpw-f-badge'),
      hAvatar : document.getElementById('kpw-f-h-avatar'),
      hTitle  : document.getElementById('kpw-f-h-title'),
      hSub    : document.getElementById('kpw-f-h-sub'),
      backBtn : document.getElementById('kpw-f-back-btn'),
      newBtn  : document.getElementById('kpw-f-new-btn'),
      closeBtn: document.getElementById('kpw-f-close-btn'),
      content : document.getElementById('kpw-f-content'),
      lightbox: lightbox,
      lightboxClose: document.getElementById('kpw-f-lightbox-close'),
    };
  }

  function svgChat(sz, color) {
    return '<svg width="'+sz+'" height="'+sz+'" viewBox="0 0 24 24" fill="none" stroke="'+color+'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
  }
  function svgBack(sz) {
    return '<svg width="'+sz+'" height="'+sz+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
  }
  function svgPlus(sz) {
    return '<svg width="'+sz+'" height="'+sz+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  }
  function svgClose(sz) {
    return '<svg width="'+sz+'" height="'+sz+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  }
  function svgSend(sz) {
    return '<svg width="'+sz+'" height="'+sz+'" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>';
  }

  var DOM = buildDOM();

  function setFabHidden(hidden) {
    var fabs = document.querySelectorAll('.kpw-f-fab, #kpw-f-fab');
    for (var i = 0; i < fabs.length; i++) {
      fabs[i].classList.toggle('is-hidden', hidden);
      fabs[i].style.display = hidden ? 'none' : '';
      fabs[i].setAttribute('aria-expanded', hidden ? 'true' : 'false');
    }
    if (document.body) {
      document.body.classList.toggle('kpw-f-panel-open', hidden);
    }
  }

  /* ════════════════════════════════════════════
   * 7. バッジ
   * ════════════════════════════════════════════ */
  function updateBadge(count) {
    var b = DOM.badge;
    if (!count || count < 1) {
      b.className = 'kpw-f-badge is-hidden'; b.textContent = '';
    } else {
      b.className = 'kpw-f-badge'; b.textContent = count > 99 ? '99+' : String(count);
    }
  }
  function calcTotalUnread() {
    var t = 0;
    for (var i = 0; i < S.threads.length; i++) t += (S.threads[i].customer_unread_count || 0);
    return t;
  }

  /* ════════════════════════════════════════════
   * 8. ヘッダー
   * ════════════════════════════════════════════ */
  function headerList() {
    DOM.hAvatar.style.display = '';
    DOM.backBtn.style.display = 'none';
    DOM.newBtn.style.display  = '';
    DOM.hTitle.textContent = 'KPW サポート';
    DOM.hSub.textContent   = 'クワガタ・カブトムシ用品専門';
  }
  function headerBack(title, sub) {
    DOM.hAvatar.style.display = 'none';
    DOM.backBtn.style.display = '';
    DOM.newBtn.style.display  = 'none';
    DOM.hTitle.textContent = title || 'KPW サポート';
    DOM.hSub.textContent   = sub   || '';
  }

  /* ════════════════════════════════════════════
   * 9. ビュー描画
   * ════════════════════════════════════════════ */
  function showLoading() {
    S.view = 'loading';
    DOM.content.innerHTML = '<div class="kpw-f-loading-wrap"><div class="kpw-f-spinner"></div></div>';
  }

  function showLogin() {
    S.view = 'login';
    headerBack('ログインが必要です', '');
    DOM.content.innerHTML = [
      '<div class="kpw-f-login-wrap">',
        '<p class="kpw-f-login-msg">お問い合わせには<br>ログインが必要です。</p>',
        '<a href="', esc(LOGIN_URL), '" class="kpw-f-login-link">ログインして問い合わせる</a>',
      '</div>',
      '</div>',
    ].join('');
  }

  function showList(threads) {
    S.view    = 'list';
    S.threads = threads || [];
    stopPoll();
    headerList();
    updateBadge(calcTotalUnread());

    var html;
    if (!S.threads.length) {
      html = [
        '<div class="kpw-f-empty">',
          '<p>まだお問い合わせはありません</p>',
          '<button type="button" class="kpw-f-btn-primary" id="kpw-f-empty-new">最初の問い合わせを送る</button>',
        '</div>',
        '</div>',
      ].join('');
    } else {
      html = '<div class="kpw-f-list-wrap" id="kpw-f-list-wrap">';
      for (var i = 0; i < S.threads.length; i++) html += buildThreadItem(S.threads[i]);
      html += '</div>';
    }
    DOM.content.innerHTML = html;

    var emptyNew = document.getElementById('kpw-f-empty-new');
    if (emptyNew) emptyNew.addEventListener('click', showNewForm);

    var listWrap = document.getElementById('kpw-f-list-wrap');
    if (listWrap) {
      listWrap.addEventListener('click', function (e) {
        var el = e.target;
        while (el && el !== listWrap) {
          if (el.hasAttribute('data-tid')) { openThread(parseInt(el.getAttribute('data-tid'), 10)); return; }
          el = el.parentElement;
        }
      });
    }
    startPoll(30000);
  }

  function buildThreadItem(t) {
    var unread  = t.customer_unread_count || 0;
    var typeLbl = TYPE_LABELS[t.type]   || t.type;
    var stLbl   = STATUS_LABELS[t.status]|| t.status;
    var typeCls = TYPE_CLASS[t.type]    || 'kpw-f-tbadge-general';
    var stCls   = STATUS_CLASS[t.status]|| 'kpw-f-tbadge-open';
    return [
      '<div class="kpw-f-thread-item', (unread ? ' has-unread' : ''), '" data-tid="', esc(String(t.id)), '">',
        '<div class="kpw-f-ti-main">',
          '<div class="kpw-f-ti-subject', (unread ? ' is-unread' : ''), '">', esc(t.subject), '</div>',
          '<div class="kpw-f-ti-time">', esc(fmtRelative(t.last_message_at)), '</div>',
        '</div>',
        '<div class="kpw-f-ti-foot">',
          '<div class="kpw-f-ti-badges">',
            '<span class="kpw-f-tbadge ', esc(typeCls), '">', esc(typeLbl), '</span>',
            '<span class="kpw-f-tbadge ', esc(stCls),   '">', esc(stLbl),   '</span>',
          '</div>',
          (unread ? '<span class="kpw-f-ti-unread">' + unread + '</span>' : ''),
        '</div>',
      '</div>',
      '</div>',
    ].join('');
  }

  function showNewForm() {
    S.view = 'form'; S.thread = null;
    clearAttachments();
    stopPoll();
    headerBack('新規お問い合わせ', IS_PRODUCT ? esc(PROD_TTL || '') : '');
    var defSub = IS_PRODUCT ? esc(PROD_TTL || '') + ' について' : '';
    DOM.content.innerHTML = [
      '<div class="kpw-f-form-wrap">',
        '<div class="kpw-f-field">',
          '<label for="kpw-f-subject" class="kpw-f-label">件名<span class="kpw-f-req">*</span></label>',
          '<input type="text" id="kpw-f-subject" class="kpw-f-input" value="', defSub, '" placeholder="例: 商品の在庫・サイズについて" autocomplete="off">',
        '</div>',
        '<div class="kpw-f-form-attachments">',
          '<div id="kpw-f-attach-preview" class="kpw-f-attach-preview" aria-live="polite"></div>',
          '<p id="kpw-f-attach-error" class="kpw-f-attach-error" aria-live="polite"></p>',
          '<input id="kpw-f-file" class="kpw-f-file-input" type="file" accept="image/*" multiple>',
          '<div class="kpw-f-form-attach-row">',
            '<span class="kpw-f-form-attach-help">JPEG・PNG・WebP・HEIC、1枚10MBまで／最大5枚</span>',
            '<label for="kpw-f-file" id="kpw-f-attach-btn" class="kpw-f-form-attach-btn">写真を追加</label>',
          '</div>',
        '</div>',
        '<div class="kpw-f-field">',
          '<label for="kpw-f-first-msg" class="kpw-f-label">メッセージ<span class="kpw-f-req">*</span></label>',
          '<textarea id="kpw-f-first-msg" class="kpw-f-input kpw-f-input-ta" rows="5" placeholder="お問い合わせ内容を入力してください"></textarea>',
        '</div>',
        '<p id="kpw-f-form-error" class="kpw-f-form-error" aria-live="polite"></p>',
        '<div class="kpw-f-form-actions">',
          '<button type="button" id="kpw-f-form-submit" class="kpw-f-btn-primary">送信する</button>',
        '</div>',
      '</div>',
      '</div>',
    ].join('');
    var btn = document.getElementById('kpw-f-form-submit');
    if (btn) btn.addEventListener('click', handleFormSubmit);
    bindAttachmentInput();
    renderAttachmentPreview();
    var sub = document.getElementById('kpw-f-subject');
    if (sub) sub.focus();
  }

  function showChat(thread) {
    S.view = 'chat'; S.thread = thread; S.currentThreadId = thread.id;
    S.msgCount = (thread.messages || []).length;
    clearAttachments();

    /* 即時既読 */
    for (var i = 0; i < S.threads.length; i++) {
      if (S.threads[i].id === thread.id) { S.threads[i].customer_unread_count = 0; break; }
    }
    updateBadge(calcTotalUnread());
    lsSet('unread', String(calcTotalUnread()));

    var typeSub = (TYPE_LABELS[thread.type] || '') + ' · ' + (STATUS_LABELS[thread.status] || '');
    headerBack(thread.subject.length > 28 ? thread.subject.slice(0,28)+'…' : thread.subject, typeSub);

    var msgs = thread.messages || [];
    var msgHtml = '', lastLabel = '';
    for (var j = 0; j < msgs.length; j++) {
      var lbl = fmtDateLabel(msgs[j].created_at);
      if (lbl !== lastLabel) { msgHtml += '<div class="kpw-f-date-sep">'+esc(lbl)+'</div>'; lastLabel = lbl; }
      msgHtml += buildMsgRow(msgs[j]);
    }
    if (!msgHtml) msgHtml = '<div class="kpw-f-empty"><p>メッセージがありません</p></div>';

    DOM.content.innerHTML = [
      '<div class="kpw-f-messages" id="kpw-f-messages">', msgHtml, '</div>',
      '<div class="kpw-f-input-stack">',
        '<div id="kpw-f-attach-preview" class="kpw-f-attach-preview" aria-live="polite"></div>',
        '<p id="kpw-f-attach-error" class="kpw-f-attach-error" aria-live="polite"></p>',
        '<input id="kpw-f-file" class="kpw-f-file-input" type="file" accept="image/*" multiple>',
        '<div class="kpw-f-input-area">',
        '<textarea id="kpw-f-chat-ta" class="kpw-f-chat-input" rows="1" placeholder="メッセージを入力… (Shift+Enterで改行)"></textarea>',
        '<label for="kpw-f-file" id="kpw-f-attach-btn" class="kpw-f-attach-btn" aria-label="写真を添付">&#128206;</label>',
        '<button type="button" id="kpw-f-send-btn" class="kpw-f-send-btn" aria-label="送信">', svgSend(15), '</button>',
      '</div>',
      '</div>',
    ].join('');

    scrollToBottom();

    var ta = document.getElementById('kpw-f-chat-ta');
    var sb = document.getElementById('kpw-f-send-btn');
    if (ta) {
      ta.addEventListener('keydown', function(e){ if (e.key==='Enter'&&!e.shiftKey){ e.preventDefault(); handleChatSend(); } });
      ta.addEventListener('input', function(){ autoResize(ta); });
      ta.focus();
    }
    if (sb) sb.addEventListener('click', handleChatSend);
    bindAttachmentInput();
    bindMessageAttachments();
    renderAttachmentPreview();

    markRead(thread.id);
    startPoll(15000);
  }

  function buildMsgRow(m) {
    var isCust = (m.sender_type === 'customer');
    var rowCls = 'kpw-f-msg-row ' + (isCust ? 'kpw-f-from-customer' : 'kpw-f-from-staff');
    var avatar = isCust ? '' : '<div class="kpw-f-msg-avatar">KPW</div>';
    return ['<div class="',rowCls,'">',avatar,'<div class="kpw-f-msg-content"><div class="kpw-f-bubble">',esc((m.body || '').replace(/\u200b/g, '')),'</div>',buildMsgAttachments(m.attachments || []),'<div class="kpw-f-msg-meta">',esc(fmtTime(m.created_at)),'</div></div></div>'].join('');
  }

  function buildMsgAttachments(attachments) {
    if (!attachments.length) return '';
    var h = '<div class="kpw-f-msg-attachments">';
    for (var i = 0; i < attachments.length; i++) {
      var a = attachments[i] || {};
      var thumb = a.thumbnail_url || a.preview_url || a.url || '';
      var preview = a.preview_url || a.thumbnail_url || a.url || '';
      if (!thumb) {
        h += '<div class="kpw-f-msg-attachment-error">画像を読み込めません</div>';
        continue;
      }
      h += '<button type="button" class="kpw-f-msg-attachment" data-kpw-preview-url="' + esc(preview) + '"><img src="' + esc(thumb) + '" alt="attachment" loading="lazy"></button>';
    }
    return h + '</div>';
  }

  function scrollToBottom() {
    var el = document.getElementById('kpw-f-messages');
    if (el) el.scrollTop = el.scrollHeight;
  }
  function autoResize(ta) {
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 100) + 'px';
  }

  function setAttachError(message) {
    var el = document.getElementById('kpw-f-attach-error');
    if (!el) return;
    el.textContent = message || '';
    el.classList.toggle('is-show', !!message);
  }

  function validateAttachments(files) {
    var total = 0;
    for (var i = 0; i < files.length; i++) {
      var fileType = files[i].type || '';
      var fileName = files[i].name || '';
      total += files[i].size || 0;
      if (!ATTACH_TYPES[fileType] && !ATTACH_EXT_RE.test(fileName)) return 'JPEG・PNG・WebP・HEIC形式の写真を選択してください';
      if ((files[i].size || 0) === 0) return '空のファイルは添付できません';
      if ((files[i].size || 0) > ATTACH_MAX_FILE_BYTES) return '写真は1枚10MBまでです';
    }
    if (files.length > ATTACH_MAX_FILES) return '写真は最大5枚までです';
    if (total > ATTACH_MAX_TOTAL_BYTES) return '写真の合計は30MBまでです';
    return '';
  }

  function clearAttachments() {
    for (var i = 0; i < S.attachmentUrls.length; i++) {
      try { URL.revokeObjectURL(S.attachmentUrls[i]); } catch(e) {}
    }
    S.attachments = [];
    S.attachmentUrls = [];
    var input = document.getElementById('kpw-f-file');
    if (input) input.value = '';
    renderAttachmentPreview();
  }

  function removeAttachment(index) {
    if (S.attachmentUrls[index]) {
      try { URL.revokeObjectURL(S.attachmentUrls[index]); } catch(e) {}
    }
    S.attachments.splice(index, 1);
    S.attachmentUrls.splice(index, 1);
    setAttachError('');
    renderAttachmentPreview();
  }

  function addAttachments(fileList) {
    var selected = Array.prototype.slice.call(fileList || []);
    var next = S.attachments.concat(selected);
    var error = validateAttachments(next);
    if (error) {
      setAttachError(error);
      return;
    }
    for (var i = 0; i < selected.length; i++) {
      S.attachments.push(selected[i]);
      S.attachmentUrls.push(URL.createObjectURL(selected[i]));
    }
    setAttachError('');
    renderAttachmentPreview();
  }

  function restoreAttachments(files) {
    clearAttachments();
    S.attachments = (files || []).slice();
    S.attachmentUrls = [];
    for (var i = 0; i < S.attachments.length; i++) {
      S.attachmentUrls.push(URL.createObjectURL(S.attachments[i]));
    }
    renderAttachmentPreview();
  }

  function renderAttachmentPreview() {
    var wrap = document.getElementById('kpw-f-attach-preview');
    if (!wrap) return;
    wrap.innerHTML = '';
    wrap.classList.toggle('is-show', S.attachments.length > 0);
    for (var i = 0; i < S.attachments.length; i++) {
      wrap.innerHTML += [
        '<div class="kpw-f-attach-item">',
          '<img src="', esc(S.attachmentUrls[i]), '" alt="attachment" data-kpw-attach-index="', i, '">',
          '<button type="button" class="kpw-f-attach-remove" data-kpw-remove-index="', i, '" aria-label="Remove image">&times;</button>',
        '</div>',
        '</div>',
      ].join('');
    }
    var imgs = wrap.querySelectorAll('[data-kpw-attach-index]');
    for (var j = 0; j < imgs.length; j++) {
      imgs[j].addEventListener('click', function(e) { openLightbox(e.currentTarget.getAttribute('src')); });
    }
    var buttons = wrap.querySelectorAll('[data-kpw-remove-index]');
    for (var k = 0; k < buttons.length; k++) {
      buttons[k].addEventListener('click', function(e) { removeAttachment(parseInt(e.currentTarget.getAttribute('data-kpw-remove-index'), 10)); });
    }
  }

  function bindMessageAttachments() {
    var buttons = document.querySelectorAll('.kpw-f-msg-attachment');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function(e) {
        openLightbox(e.currentTarget.getAttribute('data-kpw-preview-url'));
      });
      var img = buttons[i].querySelector('img');
      if (img) {
        img.addEventListener('error', function(e) {
          var box = e.currentTarget.parentNode;
          if (box) box.innerHTML = '<span class="kpw-f-msg-attachment-error">画像を読み込めません</span>';
        });
      }
    }
  }

  function bindAttachmentInput() {
    var input = document.getElementById('kpw-f-file');
    if (input) {
      input.addEventListener('change', function() {
        addAttachments(input.files || []);
        input.value = '';
      });
    }
  }

  function openLightbox(url) {
    var lb = document.getElementById('kpw-f-lightbox');
    var img = document.getElementById('kpw-f-lightbox-img');
    if (!lb || !img || !url) return;
    img.src = url;
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
  }

  function closeLightbox() {
    var lb = document.getElementById('kpw-f-lightbox');
    var img = document.getElementById('kpw-f-lightbox-img');
    if (!lb || !img) return;
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    img.removeAttribute('src');
  }

  function setChatSending(isSending) {
    var sb = document.getElementById('kpw-f-send-btn');
    var ab = document.getElementById('kpw-f-attach-btn');
    var input = document.getElementById('kpw-f-file');
    if (sb) sb.disabled = !!isSending;
    if (input) input.disabled = !!isSending;
    if (ab) {
      ab.classList.toggle('is-disabled', !!isSending);
      ab.setAttribute('aria-disabled', isSending ? 'true' : 'false');
    }
  }

  /* ════════════════════════════════════════════
   * 10. API（未ログインのみ完全停止 / CUST_IDなしは警告のみ）
   * ════════════════════════════════════════════ */
  function ensureAuthToken(required) {
    var now = Date.now();
    if (S.authToken && S.authTokenExp - now > 30000) return Promise.resolve(S.authToken);
    if (!AUTH_TOKEN_URL) {
      if (required || CUSTOMER_AUTH_REQUIRED) return Promise.reject(new Error('customer_auth_unavailable'));
      return Promise.resolve(null);
    }
    return fetch(AUTH_TOKEN_URL, { method: 'GET', credentials: 'same-origin', cache: 'no-store' }).then(function(r) {
      return r.json().catch(function(){ return {}; }).then(function(d) {
        if (!r.ok) throw new Error((d && d.error) || 'customer_auth_failed');
        if (d && d.authenticated === false) throw new Error(d.error || 'login_required');
        S.authToken = d.access_token || '';
        S.authTokenExp = Date.now() + Math.max(0, Number(d.expires_in || 0) * 1000);
        if (!S.authToken && (required || CUSTOMER_AUTH_REQUIRED)) throw new Error('customer_auth_unavailable');
        return S.authToken;
      });
    });
  }

  function guardedFetch(method, path, body, options) {
    if (!IS_LOGIN) return Promise.reject(new Error('not_authenticated'));
    if (!CUST_ID)  console.warn('[KPWFloat] customer_id missing');
    options = options || {};
    var tokenPromise = (options.requireAuth || CUSTOMER_AUTH_REQUIRED) ? ensureAuthToken(!!options.requireAuth) : Promise.resolve(S.authToken || null);
    return tokenPromise.then(function(token) {
      var isFormData = (typeof FormData !== 'undefined' && body instanceof FormData);
      var headers = isFormData ? {} : {'Content-Type':'application/json'};
      if (token) headers.Authorization = 'Bearer ' + token;
      var opts = { method: method, headers: headers };
      if (body !== undefined && body !== null) opts.body = isFormData ? body : JSON.stringify(body);
      return fetch(API_URL + path, opts).then(function(r) {
        return r.json().catch(function(){ return {}; }).then(function(d) { if (!r.ok) throw new Error((d && d.error)||'API error'); return d; });
      });
    });
  }

  function apiFetchThreadList() {
    return guardedFetch('GET', '/inquiries/threads?per_page=50', null, { requireAuth: true });
  }
  function apiFetchThread(id) {
    return guardedFetch('GET', '/inquiries/threads/' + id, null, { requireAuth: true });
  }
  function apiFetchThreadWithAttachments(id) {
    return apiFetchThread(id).then(function(thread) {
      return hydrateThreadAttachments(thread);
    });
  }
  function apiCreateThread(subject, body) {
    var p = { customer_name: CUST_NAME, customer_email: CUST_EMAIL, subject: subject, body: body, type: IS_PRODUCT ? 'product' : 'general' };
    if (IS_PRODUCT) { p.target_id = PROD_ID; p.target_handle = PROD_HDL; }
    return guardedFetch('POST', '/inquiries/threads', p, { requireAuth: true });
  }
  function apiSendMessage(threadId, body) {
    return guardedFetch('POST', '/inquiries/threads/'+threadId+'/messages', { customer_name: CUST_NAME, body: body }, { requireAuth: true });
  }
  function apiUploadAttachments(threadId, messageId, attachments) {
    var fd = new FormData();
    for (var i = 0; i < attachments.length; i++) fd.append('attachments[]', attachments[i], attachments[i].name);
    return guardedFetch('POST', '/inquiries/threads/' + threadId + '/messages/' + messageId + '/attachments', fd, { requireAuth: true }).then(function(data) {
      cacheMessageAttachments(messageId, (data && data.attachments) || []);
      return data;
    });
  }
  function apiFetchMessageAttachments(threadId, messageId) {
    return guardedFetch('GET', '/inquiries/threads/' + threadId + '/messages/' + messageId + '/attachments', null, { requireAuth: true });
  }
  function cacheMessageAttachments(messageId, attachments) {
    var list = Array.isArray(attachments) ? attachments : [];
    var ttl = 30;
    for (var i = 0; i < list.length; i++) {
      var value = Number(list[i] && list[i].expires_in);
      if (value > ttl) ttl = value;
    }
    S.attachmentCache[String(messageId)] = {
      attachments: list,
      expiresAt: Date.now() + Math.max(30, ttl - 20) * 1000,
    };
  }
  function cachedMessageAttachments(messageId) {
    var cached = S.attachmentCache[String(messageId)];
    return cached && cached.expiresAt > Date.now() ? cached.attachments : null;
  }
  function fetchMessageAttachmentsWithRetry(threadId, messageId) {
    return apiFetchMessageAttachments(threadId, messageId).catch(function() {
      return new Promise(function(resolve) { setTimeout(resolve, 250); }).then(function() {
        return apiFetchMessageAttachments(threadId, messageId);
      });
    });
  }
  function hydrateThreadAttachments(thread) {
    var messages = (thread && thread.messages) || [];
    if (!messages.length) return Promise.resolve(thread);
    var chain = Promise.resolve();
    messages.forEach(function(message) {
      chain = chain.then(function() {
        if (!message || !message.id) return;
        var cached = cachedMessageAttachments(message.id);
        if (cached !== null) { message.attachments = cached; return; }
        return fetchMessageAttachmentsWithRetry(thread.id, message.id).then(function(data) {
          message.attachments = (data && data.attachments) || [];
          cacheMessageAttachments(message.id, message.attachments);
        }).catch(function() {
          message.attachments = message.attachments || [];
        });
      });
    });
    return chain.then(function() { return thread; }).catch(function() { return thread; });
  }
  function markRead(threadId) {
    guardedFetch('POST', '/inquiries/threads/'+threadId+'/read', {}, { requireAuth: true })
      .then(function(){ updateBadge(calcTotalUnread()); lsSet('unread', String(calcTotalUnread())); })
      .catch(function(){});
  }

  /* ════════════════════════════════════════════
   * 11. ポーリング
   * ════════════════════════════════════════════ */
  function startPoll(interval) {
    stopPoll();
    S.pollTimer = setInterval(function() {
      if (!S.open) return;
      if (S.view === 'chat') pollChat();
      if (S.view === 'list') pollList();
    }, interval || 15000);
  }
  function stopPoll() { if (S.pollTimer) { clearInterval(S.pollTimer); S.pollTimer = null; } }

  function pollChat() {
    if (!S.thread) return;
    apiFetchThreadWithAttachments(S.thread.id).then(function(thread) {
      if (!S.open || S.view !== 'chat') return;
      if ((thread.messages||[]).length !== S.msgCount) showChat(thread);
      updateBadge(0);
    }).catch(function(){});
  }
  function pollList() {
    apiFetchThreadList().then(function(data) {
      if (!S.open || S.view !== 'list') return;
      S.threads = data.threads || [];
      var lw = document.getElementById('kpw-f-list-wrap');
      if (!lw) return;
      var h = '';
      for (var i = 0; i < S.threads.length; i++) h += buildThreadItem(S.threads[i]);
      lw.innerHTML = h;
      updateBadge(calcTotalUnread());
    }).catch(function(){});
  }

  function startBgPoll() {
    if (S.bgTimer) return;
    bgPollTick();
    S.bgTimer = setInterval(bgPollTick, 60000);
  }
  function bgPollTick() {
    if (!IS_LOGIN) return;
    apiFetchThreadList().then(function(data) {
      S.threads = data.threads || [];
      if (!S.open) { updateBadge(calcTotalUnread()); lsSet('unread', String(calcTotalUnread())); }
    }).catch(function(){});
  }

  /* ════════════════════════════════════════════
   * 12. パネル読み込み
   * ════════════════════════════════════════════ */
  function loadPanel() {
    if (!IS_LOGIN) { showLogin(); return; }
    if (!CUST_ID)  console.warn('[KPWFloat] customer_id missing');
    showLoading();
    apiFetchThreadList().then(function(data) {
      if (!S.open) return;
      S.threads = data.threads || [];
      showList(S.threads);
    }).catch(function() { if (S.open) showList([]); });
  }

  function openThread(id) {
    S.currentThreadId = id;
    lsSet('tid', String(id));
    showLoading(); stopPoll();
    apiFetchThreadWithAttachments(id).then(function(thread) {
      if (!S.open) return;
      showChat(thread);
    }).catch(function() { if (S.open) goBackToList(); });
  }

  function goBackToList() { stopPoll(); showList(S.threads); }

  /* ════════════════════════════════════════════
   * 13. ハンドラ
   * ════════════════════════════════════════════ */
  function handleFormSubmit() {
    if (S.sending) return;
    var subEl = document.getElementById('kpw-f-subject');
    var msgEl = document.getElementById('kpw-f-first-msg');
    var errEl = document.getElementById('kpw-f-form-error');
    var btnEl = document.getElementById('kpw-f-form-submit');
    if (!subEl || !msgEl) return;
    var subject = subEl.value.trim(), body = msgEl.value.trim();
    var formAttachments = S.attachments.slice();
    var hasAttachments = formAttachments.length > 0;
    var createdThreadId = null;
    var attachmentsUploaded = false;
    if (!subject) { errEl.textContent='件名を入力してください'; subEl.focus(); return; }
    if (!body)    { errEl.textContent='メッセージを入力してください'; msgEl.focus(); return; }
    errEl.textContent = '';
    S.sending = true;
    if (btnEl) { btnEl.disabled = true; btnEl.textContent = '送信中…'; }
    setChatSending(true);
    if (!body && hasAttachments) body = '\u200b';
    apiCreateThread(subject, body).then(function(t) {
      createdThreadId = t.id;
      lsSet('tid', String(t.id));
      if (!hasAttachments) return apiFetchThreadWithAttachments(t.id);
      return apiFetchThread(t.id).then(function(thread) {
        var messages = thread.messages || [];
        var firstMessage = messages[messages.length - 1] || {};
        if (!firstMessage.id) throw new Error('message_not_found');
        return apiUploadAttachments(t.id, firstMessage.id, formAttachments).then(function() {
          attachmentsUploaded = true;
          return apiFetchThreadWithAttachments(t.id);
        });
      });
    }).then(function(thread) {
      clearAttachments();
      S.sending = false; S.threads.unshift(thread); showChat(thread);
    }).catch(function(err) {
      S.sending = false;
      setChatSending(false);
      if (createdThreadId) {
        apiFetchThreadWithAttachments(createdThreadId).then(function(thread) {
          S.threads.unshift(thread);
          showChat(thread);
          if (!attachmentsUploaded) {
            restoreAttachments(formAttachments);
            setAttachError('お問い合わせ本文は送信済みです。写真だけ送信できませんでした。写真を確認して、もう一度送信してください。');
          } else {
            setAttachError('送信は完了しましたが、表示を更新できませんでした。しばらくしてから開き直してください。');
          }
        }).catch(function() {
          var e3 = document.getElementById('kpw-f-form-error');
          if (e3) e3.textContent = 'お問い合わせ本文は送信済みです。画面を閉じて開き直してください。';
        });
        return;
      }
      var e2 = document.getElementById('kpw-f-form-error');
      if (e2) e2.textContent = err.message || '送信に失敗しました';
      var b2 = document.getElementById('kpw-f-form-submit');
      if (b2) { b2.disabled = false; b2.textContent = '送信する'; }
    });
  }

  function handleChatSend() {
    if (S.sending || !S.thread) return;
    var ta = document.getElementById('kpw-f-chat-ta');
    if (!ta) return;
    var body = ta.value.trim();
    var hasAttachments = S.attachments.length > 0;
    var chatAttachments = S.attachments.slice();
    var messageCreated = false;
    var attachmentsUploaded = false;
    if (!body && !hasAttachments) return;
    S.sending = true;
    setChatSending(true);
    setAttachError('');

    /* 即時既読 */
    for (var i = 0; i < S.threads.length; i++) {
      if (S.threads[i].id === S.thread.id) { S.threads[i].customer_unread_count = 0; break; }
    }
    updateBadge(calcTotalUnread());
    lsSet('unread', String(calcTotalUnread()));

    /* オプティミスティックUI */
    var tempMsg = { sender_type:'customer', sender_name:CUST_NAME, body:body, created_at:new Date().toISOString() };
    var mel = document.getElementById('kpw-f-messages');
    if (mel) { var tmp = document.createElement('div'); tmp.innerHTML = buildMsgRow(tempMsg); mel.appendChild(tmp.firstChild); scrollToBottom(); }
    ta.value = ''; ta.style.height = 'auto';
    if (hasAttachments) {
      clearAttachments();
    }

    apiSendMessage(S.thread.id, body || (hasAttachments ? '\u200b' : '')).then(function(message) {
      messageCreated = true;
      if (!hasAttachments) return message;
      return apiUploadAttachments(S.thread.id, message.id, chatAttachments).then(function() {
        attachmentsUploaded = true;
        return message;
      });
    }).then(function() {
      return apiFetchThreadWithAttachments(S.thread.id);
    }).then(function(thread) {
      S.sending = false; setChatSending(false);
      if (S.view === 'chat') showChat(thread);
    }).catch(function(err) {
      S.sending = false;
      setChatSending(false);
      if (!messageCreated) {
        if (ta) ta.value = body;
        if (hasAttachments) restoreAttachments(chatAttachments);
        setAttachError('送信できませんでした。通信状態を確認して、もう一度お試しください。');
        return;
      }
      apiFetchThreadWithAttachments(S.thread.id).then(function(thread) {
        if (S.view === 'chat') showChat(thread);
        if (hasAttachments && !attachmentsUploaded) {
          restoreAttachments(chatAttachments);
          setAttachError('本文は送信済みです。写真だけ送信できませんでした。写真を確認して、もう一度送信してください。');
        } else {
          setAttachError('送信は完了しましたが、表示を更新できませんでした。しばらくしてから開き直してください。');
        }
      }).catch(function() {
        setAttachError('送信済みです。状態を更新できないため、画面を閉じて開き直してください。');
      });
    });
  }

  /* ════════════════════════════════════════════
   * 14. 開閉
   * ════════════════════════════════════════════ */
  function openPanel() {
    S.open = true;
    DOM.panel.classList.add('is-open');
    DOM.overlay.classList.add('is-open');
    setFabHidden(true);
    loadPanel();
  }
  function closePanel() {
    S.open = false;
    DOM.panel.classList.remove('is-open');
    DOM.overlay.classList.remove('is-open');
    setFabHidden(false);
    stopPoll();
  }

  /* ════════════════════════════════════════════
   * 15. イベント
   * ════════════════════════════════════════════ */
  DOM.fab.addEventListener('click', function() { S.open ? closePanel() : openPanel(); });
  DOM.closeBtn.addEventListener('click', closePanel);
  DOM.overlay.addEventListener('click', closePanel);
  DOM.backBtn.addEventListener('click', function() { if (S.view==='chat'||S.view==='form') goBackToList(); });
  DOM.newBtn.addEventListener('click', showNewForm);
  if (DOM.lightbox) DOM.lightbox.addEventListener('click', function(e) { if (e.target === DOM.lightbox) closeLightbox(); });
  if (DOM.lightboxClose) DOM.lightboxClose.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (DOM.lightbox && DOM.lightbox.classList.contains('is-open')) { closeLightbox(); return; }
    if (S.open) closePanel();
  });
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) { stopPoll(); }
    else if (S.open) { if (S.view==='chat') startPoll(15000); if (S.view==='list') startPoll(30000); }
  });

  /* ════════════════════════════════════════════
   * 16. 初期化
   * ════════════════════════════════════════════ */
  var cachedUnread = parseInt(lsGet('unread'), 10) || 0;
  if (cachedUnread > 0) updateBadge(cachedUnread);
  if (IS_LOGIN) startBgPoll();

  window.KPWFloat = { open: openPanel, close: closePanel };
  runAutoOpenMessage();

})();
